// src/pages/admin/AtcCodeMaintenancePage.jsx
import React from 'react';
import Layout from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import AtcCodeMaintenance from '../../components/AtcCodeMaintenance';

const AtcCodeMaintenancePage = () => {
  // Admins own this screen; superadmin keeps access as a superset. Layout is
  // driven by the viewer's own role so each sees their normal navigation.
  const { user } = useAuth();
  const role = user?.role === 'superadmin' ? 'superadmin' : 'admin';

  return (
    <Layout role={role}>
      <div className="container mx-auto p-6">
        <h1 className="text-3xl font-bold mb-1">ATC Codes</h1>
        <p className="text-sm text-ink-body mb-6">
          BIR Alphanumeric Tax Codes and their withholding rates. A rate change here is a data
          edit, not a redeploy — and it feeds the ATC dropdowns on Form 2306 and Form 2307 entry.
        </p>
        <AtcCodeMaintenance />
      </div>
    </Layout>
  );
};

export default AtcCodeMaintenancePage;
